import { Broker } from '@c4/core';
import { Component, OnInit } from '@angular/core';
import { AdvancedProgrammingService } from './services/advanced-programming.service';
import { Store } from '@ngrx/store';

@Component({
  selector: 'prg-advanced',
  templateUrl: './advanced.component.html',
  styleUrls: ['./advanced.component.css'],
  providers: []
})
export class AdvancedComponent implements OnInit {

  constructor(
    private advanced: AdvancedProgrammingService
  ) { }

  ngOnInit() {
    this.advanced.init();
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/advanced.component.ts